import React from "react";
import { NavigationalButtons } from "./CreateCourseWizard";
import { useFormikContext, Form, Formik, Field } from "formik";
import useAxios from "axios-hooks";
import { Label, Image, Spinner, Stack } from "@fluentui/react";

const FormFields = () => {
    const { setFieldValue } = useFormikContext();

    return (
        <>
            <Label>Upload a course icon.</Label>
            <Field type='file' name='file' onChange={
                (event) => {
                    setFieldValue('icon', event.currentTarget.files[0]);
                }
            } />
        </>
    )
}

const IconStep = ({ courseId, slug, nextOnClick, prevOnClick }) => {

    const [{ loading }, postForm] = useAxios(
        {
            url: `/courses/${courseId}/icon`,
            method: 'post',
            headers: { 'content-type': 'multipart/form-data' }

        },
        { manual: true }
    );

    if (loading) {
        return <Spinner className="absolute-center" text="Loading Icon..." />;
    }

    return (
        <div>
            <Formik
                initialValues={{ icon: null }}
                onSubmit={async (values) => {
                    if (values.icon === null) {
                        nextOnClick();
                        return;
                    }

                    const data = new FormData();

                    data.append('image', values.icon);

                    const result = await postForm({ data });

                    if (!result.isAxiosError) {
                        nextOnClick();
                    }
                }}
            >
                <Form style={{width: 600}}>
                    
                    <Image src={`https://media-cdn.igrad.com/IMAGE/Site/Course-Icons/${slug}.png`} />
                    <Stack >
                    <FormFields />
                    <label className="ms-Label root-411 mt10">Image file should be 200px by 200px circle. Must be .png.</label>
                    </Stack>
                    <NavigationalButtons
                        onNextProps={{ type: "submit", text: "Save and Continue" }}
                        onPrevHandler={prevOnClick}
                        onDeleteHandler={async () => { await postForm({ method: 'delete' }); await fetchIcon(); }}
                        onDeleteProps={{ disabled: false }}
                    />
                </Form>
            </Formik>
        </div>
    );
};

export default IconStep;
